<template>
<Nav></Nav>
  <div class="container-fluid">
    <section class="">
        <div class="content-header text-center">
            <h2>How does it work</h2>
            <p class="col-12">Get your message to the right person at the right time with global infrastructure and industry expertise you can rely on.<br>  that meets customer's needs.</p>
        </div>
        <div class="row justify-content-center">
         
          <div class="col-md-6 col-4 stick mt-2">
               
          </div>
          
        </div>
        <!-- another main options -->
        <div class="container mt-4">
          <div class="row justify-content-center p-3 animate__animated animate__bounceInUp animate__delay-1s ">
            <!--  -->
            <div class="col-md-4 mb-2 animate__animated animate__fadeInUp animate__delay-2s">
              <div class="card border-0 shadow p-3">
                  <div class="card-body p-3">
                    <div class="rounded-circle p-3">
                      <span class="font-text"> <i class="	fas fa-building"></i></span>
                    </div>
                    <div class="mt-3">
                      <h6>Built for developers</h6>
                      <p>We build everything API first with a focus on simplicity and compliance to standards.</p>
                    </div>
                  </div>
              </div>
            </div>
           <!--  -->
           <!--  -->
            <div class="col-md-4 mb-2 animate__animated animate__fadeInUp animate__delay-2s">
              <div class="card border-0 shadow p-3">
                  <div class="card-body p-3">
                    <div class="rounded-circle p-3">
                      <span class="font-text"> <i class="fas fa-tools"></i></span>
                    </div>
                    <div class="mt-3">
                      <h6>Engineered for reliability</h6>
                      <p>We’re serious about our 99.99% uptime SLA, and we’ve got the track record to prove it</p>
                    </div>
                  </div>
              </div>
            </div>
           <!--  -->
           <!--  -->
            <div class="col-md-4 animate__animated animate__fadeInUp animate__delay-2s">
              <div class="card border-0 shadow p-3">
                  <div class="card-body p-3">
                    <div class="rounded-circle p-3">
                      <span class="font-text"> <i class="fab fa-accessible-icon"></i></span>
                    </div>
                    <div class="mt-3">
                      <h6>Prepared for questions</h6>
                      <p>Help is here when you need it with free 24/7 support for all customers. You’ll feel the love.</p>
                    </div>
                  </div>
              </div>
            </div>
           <!--  -->
          </div>
          <!--  -->
          <div class="row justify-content-center p-3 mt-4 mb-5">
            <div class="col-md-6">
              <div class=" animate__animated animate__fadeInUp animate__delay-2s">
                <h6>EMAIL MARKETING FOR TEAMS</h6>
                <h2>Bring your ideas to life and deliver great campaigns with webITSecure</h2>
                <p>Create stunning emails in minutes with webITSecures best-in-class email builder. Easy to use email marketing features like segmentation, pesonalization, and a/b testing help you land right in the inbox and engage the reader. Try Mailjet today for free.</p>
                <div class="">
                    <button class="btn btn-primary" @click="goToSignup">Get Started</button>
                </div>

              </div>
            </div>
            <div class="col-md-6 animate__animated animate__fadeInUp animate__delay-2s">
                <img src="../assets/images/mailpic.svg" alt="" class="img-fluid" height="200px">
            </div>
        </div>
        <!--  -->
       
        <!-- container end here -->
        </div>

        <!-- content driving start here -->

        <div class="content-driving">
            <div class="container p-2">
              <div class="content-header text-center mt-2 p-3">
                <div>USEFUL FEATURES</div>
                <h4>Email API for application-driven emails</h4>
                <p class="content-p">Whether you’re building email campaigns that convert or apps to make people’s lives easier, Pathwire offers a <br>  comprehensive email platform so nothing stands between you and your customer.</p>
              </div>
              <!-- row start here -->
              <div class="row justify-content-center mb-4 animate__animated animate__bounce animate__delay-3s" style="">
                  <div class="col-md-4 animate__animated animate__fadeInUp animate__delay-2s">
                    <div class="card border-0 shadow-sm card-feature p-3">
                        <div class="card-body p-3">
                          <div class="rounded-circle p-3">
                            <span class="font-text"> <i class="fab fa-accessible-icon"></i></span>
                          </div>
                          <div class="mt-3">
                            <h6>Intelligent inbound routing</h6>
                            <p>Automatically parse incoming emails for easy-to-digest structured data.</p>  
                          </div>
                        </div>
                    </div>
                  </div>
                  <!--  -->
                  <div class="col-md-4 animate__animated animate__fadeInUp">
                    <div class="card border-0 shadow-sm card-feature p-3">
                        <div class="card-body p-3">
                          <div class="rounded-circle p-3">
                            <span class="font-text"> <i class="fa fa-line-chart"></i></span>
                          </div>
                          <div class="mt-3">
                            <h6>Advanced email analytics</h6>
                            <p>Gather actionable insights so every message you send performs better than the last.</p>  
                          </div>
                        </div>
                    </div>
                  </div>
                  <!--  -->
                  <div class="col-md-4 animate__animated animate__fadeInUp">
                    <div class="card border-0 shadow-sm card-feature p-3">
                        <div class="card-body p-3">
                          <div class="rounded-circle p-3">
                            <span class="font-text"> <i class="fab fa-accessible-icon"></i></span>
                          </div>
                          <div class="mt-3">
                            <h6>Responsive email templates</h6>
                            <p>Streamline collaborating with other teams and version control with our templates feature.</p>  
                          </div>
                        </div>
                    </div>
                  </div>
                  <!--  -->
              </div>
              <!-- row end here -->

            </div>
        </div>       
      <!--  -->
      <div class="container">
        <div class="content-story mt-5 mb-5 animate__animated animate__bounce animate__delay-2s">
          <div class="story-head mb-1 ">#1 IN TRANSACTIONAL EMAILS</div>
          <h6>Developers and product teams love using webITSecure  to communicate with <br> their users</h6>
          <p>Based on real customer reviews, G2 Crowd named us the #1 transactional email software. <br> Learn how our customers achieved a 1350% increase in sending speed, 817% increase in unique click rate, and other great results.</p>

          <button class="btn-story btn-primary ">Read Our stories</button>
        </div>
        <!-- conclusion -->
        <div class="row mb-5" style="margin-top:90px">
          <div class="col-md-8">
            <div class="mb-3 sub">Subscribe to the MailBox newsletter</div>
            <div class="email-box ">
              <input type="text" class="email-input form-control" placeholder="Email....">
              <button class="btn-mail btn-primary mt-n1"> <i class="fa fa-send"></i> </button>
          </div>
          <p class="mt-1">Send me the webITSecure newsletter. I expressly agree to receive the newsletter and know that I can easily unsubscribe at any time</p>
          </div>
          <div class="col-md-4 mt-4">
            <div class="">
                  <button class="btn btn-primary rounded-circle p-2"> <i class="fa fa-facebook"></i> </button>
                  <button class="btn btn-primary ml-2 rounded-circle p-2"> <i class="fa fa-twitter"></i> </button>
                  <button class="btn btn-primary ml-2 rounded-circle p-2"> <i class="fa fa-linkedin"></i> </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <Footer></Footer>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Nav from './Nav.vue'
import Footer from './Footer.vue'
export default {
  name: 'Home',
  components: {
    Nav,
    Footer
  },
  methods:{
    goToSignup:function(){
      this.$router.push('/signup')
    }
  }
}
</script>

<style lang="css" src="./index/home.css" scoped></style>
<style lang="css" src="../assets/styles.css" scoped></style>
